import { render } from "./CustomLoader1.vue?vue&type=template&id=30ea0b08&scoped=true"
const script = {}

import "./CustomLoader1.vue?vue&type=style&index=0&id=30ea0b08&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.2.2_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ea0b08"]])

export default __exports__